import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { MMDetails, PAMMCheckResponse, PAMMManagerOffer, PAMMStep } from "../../utils/pamm"
import { AccountStat, Currency } from "../../utils/types"

export type PAMMState = {
    inProgress: boolean
    step: PAMMStep
    offer: PAMMManagerOffer | null
    managerId: number
    manager: MMDetails | null
    offerId: string
    account: AccountStat | null
    accountInfo: PAMMCheckResponse | null
    inviteLink: string
    reinvesting: boolean
    currencies: Currency[]
    checkAccount: number | null
    documentVersion: string
}

const initialState: PAMMState = {
    inProgress: false,
    step: 'main',
    offer: null,
    managerId: 0,
    manager: null,
    offerId: '',
    account: null,
    accountInfo: null,
    inviteLink: '',
    reinvesting: false,
    currencies: [],
    checkAccount: null,
    documentVersion: ''
}

const slice = createSlice({
    name: "pamm",
    initialState: initialState,
    reducers: {
        updatePAMM: (state: PAMMState, action: PayloadAction<Partial<PAMMState>>) => {
            Object.assign(state, action.payload)
        }
    }
})

const { actions, reducer } = slice

export const { updatePAMM } = actions
export default reducer
